import { render, staticRenderFns } from "./ColorIndicator.vue?vue&type=template&id=2155e285&scoped=true"
import script from "./ColorIndicator.vue?vue&type=script&lang=js"
export * from "./ColorIndicator.vue?vue&type=script&lang=js"
import style0 from "./ColorIndicator.vue?vue&type=style&index=0&id=2155e285&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155e285",
  null
  
)

export default component.exports